import { withTheme } from '@material-ui/core';

const styles = (theme) => ({
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  avatar: {
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  root: {
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing.unit * 1.75,
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: 0,
    },
  },
  rootNoPadding: {},
  chevronIcon: {
    verticalAlign: 'middle',
  },
  body: {
    fontSize: '1.1875rem',
    paddingTop: theme.spacing.unit * 2,
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  cardSubheading: {
    fontSize: '1.375rem',
    fontWeight: 400,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.125rem',
    },
  },
  expansionPanel: {
    boxShadow: 'none',
  },
  expansionPanelTitle: {
    fontSize: '1.1875rem',
    width: '100%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  expansionPanelDetails: {
    padding: `0 0 16px`,
    flexDirection: 'column',
  },
  expansionPanelContent: {
    fontSize: '1.1875rem',
    width: '100%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  expandIcon: {
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
      borderRadius: '5px',
    },
  },
});

export default styles;
